import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import MobileBottomNav from "./MobileBottomNav";
import BoostJoinBanner from "@/components/BoostJoinBanner";

export default function MobileShell({ title, subtitle, back = false, action, children, noPad = false, darkHeader = true }) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen pb-20" style={{ background: "#F0F2F5" }}>
      {/* Top bar — Apple iOS style */}
      <header
        className="sticky top-0 z-30 safe-top"
        style={{
          background: darkHeader
            ? "linear-gradient(180deg, #0A192F 0%, #0D1E35 100%)"
            : "rgba(255,255,255,0.94)",
          backdropFilter: darkHeader ? "none" : "blur(20px) saturate(180%)",
          WebkitBackdropFilter: darkHeader ? "none" : "blur(20px) saturate(180%)",
          borderBottom: darkHeader ? "none" : "1px solid rgba(10,25,47,0.07)",
          boxShadow: darkHeader ? "0 1px 0 rgba(0,0,0,0.2)" : "0 1px 0 rgba(10,25,47,0.04)",
        }}
        data-testid="mobile-header"
      >
        <div className="flex items-center gap-2 px-4 py-3 min-h-[56px]">
          {back && (
            <button
              onClick={() => nav(-1)}
              data-testid="mobile-back"
              className="flex items-center gap-0.5 -ml-1 mr-1 active:opacity-60 transition-opacity shrink-0"
              style={{ color: darkHeader ? "#B7955B" : "#0A192F" }}
            >
              <ChevronLeft className="w-5 h-5" strokeWidth={2} />
            </button>
          )}
          <div className="flex-1 min-w-0">
            {subtitle && (
              <p className="text-[9px] font-semibold uppercase tracking-[0.2em] leading-none mb-0.5"
                style={{ color: darkHeader ? "rgba(183,149,91,0.8)" : "#B7955B" }}>
                {subtitle}
              </p>
            )}
            <h1
              className="font-serif leading-tight truncate"
              style={{
                fontSize: "1.15rem",
                fontWeight: 300,
                color: darkHeader ? "#fff" : "#0D1829",
                letterSpacing: "-0.01em",
              }}
            >
              {title}
            </h1>
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      </header>

      {/* Body */}
      <main className={noPad ? "" : "px-4 py-4"}>
        {children}
      </main>

      <MobileBottomNav />
      <BoostJoinBanner />
    </div>
  );
}
